import { Locale } from '@cumu/strings';

export function equalsIgnoreCase(
  a: string,
  b: string,
  locale: Locale = 'en'
): boolean {
  return a.localeCompare(b, locale, { sensitivity: 'base' }) === 0;
}

export function compareIgnoreCase(
  a: string,
  b: string,
  locale: Locale = 'en'
): number {
  return a.localeCompare(b, locale, { sensitivity: 'base' });
}
